import React, {Component} from 'react'
import {Divider, Spin} from 'antd'
import CardInput from './CardInput'
import ListArtworks from './artworks/ListArtworks'
import CreateBatch from './batch/CreateBatch'
import {brandingInfo} from "../../../services/api/3dApi"

class InCardPage extends Component {
    state = {
        loading: false,
        errors: [],
        inputValue: '',
        error: '',
        value: '',
        arrBarcodes: [],
        artworks: []
    }

    _handleChangeInput = (e) => {
        const {value: oldValue, inputValue} = this.state
        const {value} = e.target

        const newValue = (inputValue.length > 0 && value.length > inputValue.length) ? value.slice(value.indexOf(inputValue) + inputValue.length) : `${oldValue}${value}`

        this.setState({
            value: newValue.trim(),
            inputValue: ''
        })
    }

    _handleSubmitInCard = (e) => {
        e.preventDefault()
        const {value, arrBarcodes} = this.state

        const check = /^#\d+_/.test(value.trim())
        if (!check) return this.setState({
            error: '',
            value: '',
            errors: [],
        })

        this.setState({
            inputValue: value.trim(),
            value: '',
            arrBarcodes: arrBarcodes.concat([value.trim()])
        }, () => {
            this._handleGetArtworks()
        })
    }

    _handleGetArtworks = async () => {
        const {arrBarcodes} = this.state
        this.setState({
            error: '',
            errors: [],
            loading: true
        })

        try {
            const payload = {
                barcodes: arrBarcodes
            }

            const {data: response} = await brandingInfo(payload)

            const {success, data, error} = response

            if (!success) return this.setState({
                error: error,
                loading: false,
                artworks: [],
            })

            const {rows, errors} = data

            const newBarcodes = rows.map(itemBarcode => {
                return `#${itemBarcode.barcode_number}_${itemBarcode.item_number}`
            })

            this.setState({
                artworks: rows,
                errors: errors,
                arrBarcodes: newBarcodes,
                loading: false
            })
        } catch (e) {
            this.setState({
                loading: false,
                error: e.message
            })
        }
    }

    _handleClear = () => {
        this.setState({
            loading: false,
            error: '',
            value: '',
            inputValue: '',
            arrBarcodes: [],
            artworks: [],
            errors: [],
        })
    }

    _handleDeleteItem = (barcode) => {
        const {arrBarcodes, artworks} = this.state

        const newArtworks = artworks.filter(itemArtwork => `#${itemArtwork.barcode_number}_${itemArtwork.item_number}` !== barcode)
        const newBarcode = arrBarcodes.filter(itemBarcode => itemBarcode !== barcode)

        this.setState({
            arrBarcodes: newBarcode,
            artworks: newArtworks,
            inputValue: '',
            value: '',
        })
    }

    render() {
        const {error, errors, loading, artworks, inputValue, arrBarcodes} = this.state

        return (
            <div className='p-3 mb-3'>
                <h1>In card</h1>
                <CardInput onSubmit={this._handleSubmitInCard} error={error} errors={errors} loading={loading}
                           value={inputValue} onChangeInput={this._handleChangeInput} onClose={this._handleClear}/>
                {
                    artworks.length > 0 && (
                        <div className="bg-white p-4 mt-4">
                            <CreateBatch barcodes={arrBarcodes} onClear={this._handleClear}/>
                            <Divider>Design</Divider>
                            <Spin tip="Loading..." spinning={loading}>
                                <ListArtworks onDeleteItem={this._handleDeleteItem} artworks={artworks}/>
                            </Spin>
                        </div>
                    )
                }
            </div>
        )
    }
}

export default InCardPage
